import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';

import Whatsapp from '../components/landingpage/whatsapp'
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue, onValueChange } from "firebase/database";
import Header from "./header";
import Footer from "./footer";
import Breadcrumbs from "./breadcrumbs";
import ProductQuote from "./get_product_quote"; 
import Error404 from "../pages/Error404";


function Product_Detail() {

  const navigate = useNavigate();
  const location = useLocation();
  const [sheet, setSheet] = useState([
    {
      id: 1,
      name: "",
      quantity: "",
      piece: "",
      price: "",
      des: "",
      status: "normal",
    },
  ]);

  const [mesg, setMesg] = useState("");
  const [pid, setpid] = useState("");
  const [uid, setUid] = useState("");
  const [piduser, setpidUser] = useState("");
  const [catid, setcatid] = useState("");
  const [chatid, setChatid] = useState("");
  const [chatUser, setChatUser] = useState("");

  const [user, setUser] = useState([]);
  const [allcats, setAllcats] = useState([]);
  const [alert2, setAlert2] = useState(false);
  const [allUID, setAllUID] = useState([]);
  const [allSimilar, setAllSimilar] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [errors, setErrors] = useState({});


  const [profile, setProfile] = useState([]);
  const [company, setCompany] = useState([]);
  const [cname, setCname] = useState("");
  const [imgCompany, setImgCompany] = useState([]);
  const [logo, setImgLogo] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const { id, slug } = useParams();
  const [hasFetched, setHasFetched] = useState(false);

  const slugify = (name) => {
    return decodeURIComponent(decodeURIComponent(name))
      .replace(/\s+/g, "-")
      .replace(/%20/g, "-")
      .replace(/%2520/g, "-")
      .replace(/[^a-zA-Z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .trim()
      .toLowerCase();
  };
  

  // 🔁 Client-side redirect from ?id=...&s=... to /product/id/slug
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const legacyId = params.get("id");
    const legacySlug = params.get("s");
  
    if (legacyId && legacySlug && !id) {
      const formattedSlug = slugify(legacySlug);
      navigate(`/product/${legacyId}/${formattedSlug}`, { replace: true });
    }
  }, [location.search, id, navigate]);  
  

const insertProductView = async (product_id) => {
    if (!product_id) return;

    var viewer_id = 0;

    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);
      viewer_id = as[0].id;
    }
    
    const ip = await fetch("https://api.ipify.org?format=json").then(res => res.json()).then(data => data.ip);
    const data = new FormData();
    data.append("product_id", product_id);
    data.append("viewer_id", viewer_id ?? 0);
    data.append("ip", ip);
  
    axios.post("/pro/analytics/insert_product_view.php", data)
      .then(res => console.log("Product view inserted"))
      .catch(err => console.log("Error", err));
  };
  
  const CompanyProfileView = async (id) => {
    const data = new FormData();
    data.append("uid", id);
  
    axios({
      method: "post",
      url: "/pro/profile/profile_view_company.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        const dd = s.data[0]?.aray_pprofile || [];
        const d = s.data[0]?.aray_com || [];
  
        console.log("company Profile", dd);
  
        setProfile(dd);
        setCompany(d);
  
        if (dd.length > 0) {
          setCname(dd[0].companyname);
        }
      })
      .catch((s) => {
        console.log("here catch =>>", s);
      });
  };  


  useEffect(() => {
    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);

      // console.log("sss", as);
      setUser(as);

      setUid(as[0].id);
    } else {
      // console.log("Login Please");
    }

    if (id) {
      getServercats();
    }
  }, [id]);

  const parseHtmlAndTruncate = (html, length) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    let textContent = doc.body.innerHTML || "";
    
    // Preserve line breaks and spacing
    textContent = textContent.replace(/\n/g, "<br>");
    
    return textContent.length > length
      ? textContent.substring(0, length) + "..."
      : textContent;
  };

  const getServercats = async () => {

    setpid(id);

    const data = new FormData();
    data.append("id", id);

    insertProductView(id);

    axios({
      method: "post",
      url: "/mainsite/productbyid.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setHasFetched(true);
        setAllcats(s.data);

        const actualName = s.data[0].name;
        const expectedSlug = slugify(actualName);
        const currentSlug = slug || "";

  
        if (expectedSlug !== currentSlug) {
          navigate(`/product/${id}/${expectedSlug}`, { replace: true });
          return; // Stop further execution until URL is corrected
        }


        
        getServerUID(s.data[0].uid);
        setcatid(s.data[0].cat);
        changeArayquote(0, { name: s.data[0].name });
        getServerSimilar(s.data[0].cat);
        setpidUser(s.data[0].uid);
        CompanyProfileView(s.data[0].uid);
        ViewImgCompany(s.data[0].uid)
        // console.log("product", s.data);
        // Check if meta_title and meta_description exist and are not empty
        setTimeout(() => {

          if (s.data.length > 0) {
            // Check and update <title>
            if (s.data[0].meta_title && s.data[0].meta_title.trim() !== "") {
              document.title = s.data[0].meta_title;
          
              const twitterTitle = document.querySelector('meta[name="twitter:title"]');
              if (twitterTitle) {
                twitterTitle.setAttribute("content", s.data[0].meta_title);
              }
          
              const ogTitle = document.querySelector('meta[property="og:title"]');
              if (ogTitle) {
                ogTitle.setAttribute("content", s.data[0].meta_title);
              }
            }
          
            // Check and update <meta name="description">
            if (s.data[0].meta_description && s.data[0].meta_description.trim() !== "") {
              const metaDesc = document.querySelector('meta[name="description"]');
              if (metaDesc) {
                metaDesc.setAttribute("content", s.data[0].meta_description);
              }
          
              const ogDesc = document.querySelector('meta[property="og:description"]');
              if (ogDesc) {
                ogDesc.setAttribute("content", s.data[0].meta_description);
              }
            }
          }          
        }, 100); // 500ms delay to ensure DOM is fully loaded


      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };
  const getServerUID = async (uid) => {
    const data = new FormData();

    data.append("uid", uid);

    axios({
      method: "post",
      url: "/mainsite/productbyuid.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setAllUID(s.data);
        setChatUser(s.data[0].uid);
        // console.log("Product By Uid", s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  const getServerSimilar = async (cat) => {
    const data = new FormData();
    data.append("cat", cat);

    axios({
      method: "post",
      url: "/mainsite/productbycat.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setAllSimilar(s.data);
        // console.log(" set All Similar ", s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  const ViewImgCompany = async (uid) => {
    const data = new FormData();
    data.append('uid', uid);
    data.append('val', "view");
    axios({
      method: 'post',
      url: '/pro/profile/manage_profile_images.php',
      data: data,
      headers: {'Content-Type': 'multipart/form-data'},
    })
      .then(s => {
        setImgCompany(s.data)

        setImgLogo(s.data.find(item => item.type === "logo"));

        console.log("compny images",s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const changeArayquote = (i, changes) => {
    const oldArr = [...sheet];
    const oldObj = oldArr[i];
    oldArr[i] = { ...oldObj, ...changes };
    setSheet(oldArr);
  };


  const [selectedImage, setSelectedImage] = useState(null);




  const openImage = (imageUrl) => {
    setSelectedImage(imageUrl); // Open the clicked image in full-screen
  };

  const closeImage = () => {
    setSelectedImage(null); // Close the full-screen view
  };

  const generateAvatar = (name, size = 200) => {
    // Extract initials
    if(name == "") {
      return "/assets/images/retail-store-icon.png"; 
    }
    const words = name.trim().split(/\s+/); // Split by spaces
    const initials = words.length > 1 
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase() // First letter of first and second word
        : words[0][0].toUpperCase(); // Only first letter if one word

    // FNV-1a hashing for unique hash
    const generateColorFromName = (name) => {
        let hash = 2166136261; // FNV-1a 32-bit offset basis
        for (let i = 0; i < name.length; i++) {
            hash ^= name.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        // Convert hash to RGB values
        const r = (hash & 0xFF0000) >> 16; // Red
        const g = (hash & 0x00FF00) >> 8;  // Green
        const b = hash & 0x0000FF;         // Blue
        return `rgb(${r}, ${g}, ${b})`;    // Return as RGB string
    };

    const bgColor = generateColorFromName(name);

    // Create canvas
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');

    // Background color
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    // Text styling
    ctx.fillStyle = '#ffffff';
    ctx.font = `${size / 2}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, size / 2, size / 2);

    // Return the image data URL
    return canvas.toDataURL('image/png');
  };

  return (
    <>
      <Header />
      <main className="main"  style={{minHeight:'50vh'}}>

        {/* <div className="container">
          <div className="product-images">
            <img src="https://alahdeen.com/assets/images/banner/1.png" alt="Main Product" className="main-image" />
            Additional thumbnails can be placed here
          </div>
          
        </div> */}

{hasFetched && allcats.length === 0 ? (
  <Error404 message="Not found" />
) : allcats.length === 0 ? <Error404 message={"Plase Wait,.."}  /> : (

allcats.map((v, i) => (
        <div key={i}>
          <Breadcrumbs categoryId={v.cat} />
          <div className="container mb-4">
            <div className="row align-items-stretch">

            <div className="col-lg-12">
    <div className="container mt-1 main-heading-style">
      <h3 className="fw-bold text-center">Product Details</h3>
    </div>
  </div>

 {/* Image Carousel Section with Thumbnails */}
<div className="col-12 col-lg-6 d-flex">
  <div className="product-image-slider box-shadow flex-fill d-flex flex-column align-items-center"
    style={{
      borderRadius: "25px",
      backgroundColor: "#fff",
      minHeight: "100%",
      padding: "20px",
    }}
  >
    <Carousel
      className="w-100 py-3"
      variant="dark"
      style={{ borderRadius: "25px", width: "100%", maxHeight: "80%" }}
      activeIndex={activeIndex}
      onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
    >
      {[v.img, v.img_a, v.img_b].filter(imgSrc => imgSrc).map((imgSrc, index) => (
        <Carousel.Item key={index} style={{ borderRadius: "25px" }}>
          <div className="d-flex align-items-center justify-content-center w-100"
            style={{
              width: "100%",
              height: "500px", // Adjust height dynamically
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
              borderRadius: "25px",
            }}
          >
            <img
              src={imgSrc}
              alt={`Slide ${index + 1}`}
              className="d-block"
              style={{
                maxWidth: "90%", // Maintain image responsiveness
                maxHeight: "90%",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "25px",
              }}
              onClick={() => openImage(imgSrc)}
            />
          </div>
        </Carousel.Item>
      ))}
    </Carousel>

    {/* Thumbnail Navigation */}
    <div className="thumbnail-container d-flex justify-content-center mt-3"
      style={{ width: "100%", flexWrap: "wrap" }} // Ensuring proper spacing
    >
      {[v.img, v.img_a, v.img_b].filter(imgSrc => imgSrc).map((imgSrc, index) => (
        <div key={index} className={`thumbnail-box mx-2 ${activeIndex === index ? 'active-thumbnail' : ''}`}
          onClick={() => setActiveIndex(index)}
          style={{
            width: "70px",
            height: "70px",
            cursor: "pointer",
            borderRadius: "10px",
            border: activeIndex === index ? "2px solid #1A78B4" : "1px solid lightgray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            margin: "5px", // Adding spacing between thumbnails
          }}
        >
          <img
            src={imgSrc}
            alt={`Thumbnail ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "10px",
            }}
          />
        </div>
      ))}
    </div>
  </div>
</div>


              {/* Product Details Section */}
              <div className="col-12 col-lg-6 d-flex">
                <div className="product-details box-shadow flex-fill"
                  style={{
                    padding: "44px 33px 32px 33px",
                    borderRadius: "25px",
                    minHeight: "100%",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-end mt-3">
                    <h1 className="product-title fs-2 m-0" style={{ color: "#425A8B", fontSize: "28px", fontWeight: 700 }}>
                      {v.name}
                    </h1>
                  </div>
                  <div className="d-flex justify-content-between align-items-end my-3">
                    <h3 className="price fs-3 font-bold m-0" style={{ fontSize: "32px", color: "#010101" }}>
                    {v.price != 0 ? 'Price:' : '' } <span style={{fontSize: "32px", color: "red"}}>{v.price != 0 ? new Intl.NumberFormat("en-PK", {
  style: "currency",
  currency: "PKR",
  minimumFractionDigits: 2,
}).format(v.price) : window.zero_price}</span><br />
                      {v.pro_price !== "" && <>Discount Price: <span style={{fontSize: "32px", color: "red"}}>Rs {v.pro_price}</span></>}
                    </h3>
                  </div>

                  {(v.minimum_quantity || v.barcode || v.delivery) && (
  <div className="py-4" style={{ borderTop: "2px solid #DDE4F0" }}>
    <ul className="list-dot" style={{ color: "#425A8B", fontSize: "14px", lineHeight: "18px" }}>
      {v.minimum_quantity && <li>Min Order Qty: {v.minimum_quantity}</li>}
      {v.barcode && <li>SKU Code: {v.barcode}</li>}
      {v.delivery && <li>Delivery Time: {v.delivery}</li>}
    </ul>
  </div>
)}


                  {/* Get Product Quote Form */}
                  <ProductQuote
                    product={v}
                    user={user}
                    uid={uid}
                    piduser={piduser}
                    navigate={navigate}
                  />

{/* ✅ Enhanced About the Seller Section */}
<div
  className="mt-2 mb-4"
  style={{
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
  }}
>
  {/* Heading */}
  <h5
    className="main-heading-style mb-4"
  >
    About the Seller
  </h5>

  {/* Content Section */}
  <div className="d-flex flex-wrap align-items-center justify-content-between">
    {/* Logo and Info */}
    <div className="d-flex align-items-center">
      {/* Circular Image Container */}
      <div
        style={{
          position: "relative",
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          overflow: "hidden",
          border: "3px solid #4f97a1",
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginRight: "15px",
        }}
      >
        <img
          src={logo?.image || generateAvatar(cname)}
          alt="Company Logo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      </div>

      {/* Seller Info */}
      <div className="seller-info">
        <p style={{ fontSize: "16px", color: "#1D1D1D", fontWeight: 500, marginBottom: "5px" }}>
          {cname}
        </p>
        <p style={{ fontSize: "14px", color: "#555", marginBottom: 0 }}>
          {profile[0] && profile[0].address}
        </p>
      </div>
    </div>

    {/* Visit Company Button */}
    <div className="mt-4">
      <button
        onClick={() => navigate(`/companydetail/${v.uid}/${cname || ''}`)}
        className="border-0 rounded-pill px-4 py-2"
        style={{
          backgroundColor: "#1A78B4",
          color: "#fff",
          fontWeight: 500,
          fontSize: "14px",
        }}
      >
        Company Website
      </button>
    </div>
  </div>
</div>


                </div>
              </div>

              {v?.des && v?.des.length > 0 && (
  <div className="col-12 col-lg-12 d-flex">
    <div
      className="product-image-slider box-shadow flex-fill d-flex flex-column"
      style={{
        borderRadius: "25px",
        backgroundColor: "#fff",
        minHeight: "100%",
        padding: "20px",
      }}
    >
      <h4 className="main-heading-style py-3 text-left" style={{ color: "#1A78B4" }}>Descriptions</h4>

      <div className="productDetails discStyle">
        {v?.des?.length > 1000 ? (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: expanded ? v?.des : parseHtmlAndTruncate(v?.des, 1000),
              }}
              style={{ fontSize: "16px", lineHeight: "1.6", whiteSpace: "pre-line" }}
            />
            <button
              onClick={() => setExpanded(!expanded)}
              className="btn btn-primary read-more-btn"
              style={{ color: "whitesmoke", backgroundColor: "#1A78B4", marginTop: "20px", marginBottom: "20px" }}
            >
              {expanded ? "Read Less" : "Read More"}
            </button>
          </>
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: v?.des.replace(/\n/g, "<br>") }}
            style={{ fontSize: "16px", lineHeight: "1.6", whiteSpace: "pre-line" }}
          />
        )}
      </div>
    </div>
  </div>
)}

            </div>
          </div>
        </div>
      ))

    )}

        <div
          className="modal fade"
          id="ModalFiltersForm"
          tabIndex={-1}
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content apply-job-form">
              <div className="modal-header">
                <h5 className="modal-title color-gray-1000 filters-icon">
                  Addvance Fillters
                </h5>
                <button
                  className="btn-close"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-30">
                <div className="row">
                  <div className="col-w-1">
                    <h6 className="color-gray-900 mb-0">Brands</h6>
                    <ul className="list-checkbox">
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" defaultChecked="checked" />
                          <span className="text-small">Apple</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Samsung</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Baseus</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Remax</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Handtown</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Elecom</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Razer</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Auto Focus</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Nillkin</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Logitech</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">ChromeBook</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="col-w-1">
                    <h6 className="color-gray-900 mb-0">Special offers</h6>
                    <ul className="list-checkbox">
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">On sale</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" defaultChecked="checked" />
                          <span className="text-small">FREE shipping</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Big deals</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Shop Mall</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                    </ul>
                    <h6 className="color-gray-900 mb-0 mt-40">Ready to ship in</h6>
                    <ul className="list-checkbox">
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">1 business day</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" defaultChecked="checked" />
                          <span className="text-small">1–3 business days</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">in 1 week</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Shipping now</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="col-w-1">
                    <h6 className="color-gray-900 mb-0">Ordering options</h6>
                    <ul className="list-checkbox">
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Accepts gift cards</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Customizable</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" defaultChecked="checked" />
                          <span className="text-small">Can be gift-wrapped</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Installment 0%</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                    </ul>
                    <h6 className="color-gray-900 mb-0 mt-40">Rating</h6>
                    <ul className="list-checkbox">
                      <li className="mb-5">
                        <a href="#">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <span className="ml-10 font-xs color-gray-500 d-inline-block align-top">
                            (5 stars)
                          </span>
                        </a>
                      </li>
                      <li className="mb-5">
                        <a href="#">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <span className="ml-10 font-xs color-gray-500 d-inline-block align-top">
                            (4 stars)
                          </span>
                        </a>
                      </li>
                      <li className="mb-5">
                        <a href="#">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <span className="ml-10 font-xs color-gray-500 d-inline-block align-top">
                            (3 stars)
                          </span>
                        </a>
                      </li>
                      <li className="mb-5">
                        <a href="#">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <span className="ml-10 font-xs color-gray-500 d-inline-block align-top">
                            (2 stars)
                          </span>
                        </a>
                      </li>
                      <li className="mb-5">
                        <a href="#">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <img
                            src="assetsss/imgs/template/icons/star-gray.svg"
                            alt="Ecom"
                          />
                          <span className="ml-10 font-xs color-gray-500 d-inline-block align-top">
                            (1 star)
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-w-2">
                    <h6 className="color-gray-900 mb-0">Material</h6>
                    <ul className="list-checkbox">
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Nylon (8)</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Tempered Glass (5)</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" defaultChecked="checked" />
                          <span className="text-small">
                            Liquid Silicone Rubber (5)
                          </span>
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <label className="cb-container">
                          <input type="checkbox" />
                          <span className="text-small">Aluminium Alloy (3)</span>
                          <span className="checkmark" />
                        </label>
                      </li>
                    </ul>
                    <h6 className="color-gray-900 mb-20 mt-40">Product tags</h6>
                    <div>
                      <a className="btn btn-border mr-5" href="#">
                        Games
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Electronics
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Video
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Cellphone
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Indoor
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        VGA Card
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        USB
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Lightning
                      </a>
                      <a className="btn btn-border mr-5" href="#">
                        Camera
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-start pl-30">
                <a className="btn btn-buy w-auto" href="#">
                  Apply Fillter
                </a>
                <a className="btn font-sm-bold color-gray-500" href="#">
                  Reset Fillter
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="ModalQuickview"
          tabIndex={-1}
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content apply-job-form">
              <button
                className="btn-close"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="modal-body p-30">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="gallery-image">
                      <div className="galleries-2">
                        <div className="detail-gallery">
                          <div className="product-image-slider-2">
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-1.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-2.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-3.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-4.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-5.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-6.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-7.jpg"
                                alt="product image"
                              />
                            </figure>
                          </div>
                        </div>
                        <div className="slider-nav-thumbnails-2">
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-1.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-2.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-3.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-4.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-5.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-6.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-7.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box-tags">
                      <div className="d-inline-block mr-25">
                        <span className="font-sm font-medium color-gray-900">
                          Category:
                        </span>
                        <a className="link" href="#">
                          Smartphones
                        </a>
                      </div>
                      <div className="d-inline-block">
                        <span className="font-sm font-medium color-gray-900">
                          Tags:
                        </span>
                        <a className="link" href="#">
                          Blue
                        </a>
                        ,
                        <a className="link" href="#">
                          Smartphone
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="product-info">
                      <h5 className="mb-15">
                        SAMSUNG Galaxy S22 Ultra, 8K Camera &amp; Video, Brightest
                        Display Screen, S Pen Pro
                      </h5>
                      <div className="info-by">
                        <span className="bytext color-gray-500 font-xs font-medium">
                          by
                        </span>
                        <a
                          className="byAUthor color-gray-900 font-xs font-medium"
                          href="shop-vendor-list.html"
                        >
                          {" "}
                          Ecom Tech
                        </a>
                        <div className="rating d-inline-block">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <span className="font-xs color-gray-500 font-medium">
                            {" "}
                            (65 reviews)
                          </span>
                        </div>
                      </div>
                      <div className="border-bottom pt-10 mb-20" />
                      <div className="box-product-price">
                        <h3 className="color-brand-3 price-main d-inline-block mr-10">
                          $2856.3
                        </h3>
                        <span className="color-gray-500 price-line font-xl line-througt">
                          $3225.6
                        </span>
                      </div>
                      <div className="product-description mt-10 color-gray-900">
                        <ul className="list-dot">
                          <li>8k super steady video</li>
                          <li>Nightography plus portait mode</li>
                          <li>50mp photo resolution plus bright display</li>
                          <li>Adaptive color contrast</li>
                          <li>premium design &amp; craftmanship</li>
                          <li>Long lasting battery plus fast charging</li>
                        </ul>
                      </div>
                      <div className="box-product-color mt-10">
                        <p className="font-sm color-gray-900">
                          Color:
                          <span className="color-brand-2 nameColor">Pink Gold</span>
                        </p>
                        <ul className="list-colors">
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-1.jpg"
                              alt="Ecom"
                              title="Pink"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-2.jpg"
                              alt="Ecom"
                              title="Gold"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-3.jpg"
                              alt="Ecom"
                              title="Pink Gold"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-4.jpg"
                              alt="Ecom"
                              title="Silver"
                            />
                          </li>
                          <li className="active">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-5.jpg"
                              alt="Ecom"
                              title="Pink Gold"
                            />
                          </li>
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-6.jpg"
                              alt="Ecom"
                              title="Black"
                            />
                          </li>
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-7.jpg"
                              alt="Ecom"
                              title="Red"
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="box-product-style-size mt-10">
                        <div className="row">
                          <div className="col-lg-12 mb-10">
                            <p className="font-sm color-gray-900">
                              Style:
                              <span className="color-brand-2 nameStyle">S22</span>
                            </p>
                            <ul className="list-styles">
                              <li className="disabled" title="S22 Ultra">
                                S22 Ultra
                              </li>
                              <li className="active" title="S22">
                                S22
                              </li>
                              <li title="S22 + Standing Cover">
                                S22 + Standing Cover
                              </li>
                            </ul>
                          </div>
                          <div className="col-lg-12 mb-10">
                            <p className="font-sm color-gray-900">
                              Size:
                              <span className="color-brand-2 nameSize">512GB</span>
                            </p>
                            <ul className="list-sizes">
                              <li className="disabled" title="1GB">
                                1GB
                              </li>
                              <li className="active" title="512 GB">
                                512 GB
                              </li>
                              <li title="256 GB">256 GB</li>
                              <li title="128 GB">128 GB</li>
                              <li className="disabled" title="64GB">
                                64GB
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="buy-product mt-5">
                        <p className="font-sm mb-10">Quantity</p>
                        <div className="box-quantity">
                          <div className="input-quantity">
                            <input
                              className="font-xl color-brand-3"
                              type="text"
                              defaultValue={1}
                            />
                            <span className="minus-cart" />
                            <span className="plus-cart" />
                          </div>
                          <div className="button-buy">
                            <a className="btn btn-cart" href="shop-cart.html">
                              Add to cart
                            </a>
                            <a className="btn btn-buy" href="shop-checkout.html">
                              Buy now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {/* Fullscreen Image Modal */}
      {selectedImage && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1050 }} // Increase z-index to 1050
          onClick={closeImage}
        >
          <img
            src={selectedImage}
            alt="fullscreen"
            className="img-fluid"
            style={{ maxHeight: '90%', maxWidth: '90%' }}
          />
          <button
            className="position-absolute top-0 end-0 m-3 btn btn-light"
            onClick={closeImage}
          >
            Close
          </button>
        </div>

      )}

    </>

  )
}

export default Product_Detail